// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation__2S5BO","Navigation_heading":"Navigation_heading__2S5BO"};